import { ProcessingChannel, ProcessingChannelsResponseBody } from './types';

export const mapResponseToProcessingChannels = (
  data: ProcessingChannelsResponseBody,
): ProcessingChannel[] => {
  return data.channels.map((channel) => ({
    id: channel.id,
    entityId: channel.entity_id,
    name: channel.name,
  }));
};

export const filterProcessingChannels = (
  processingChannels: ProcessingChannel[],
  acceptedEntityIds: string[],
): ProcessingChannel[] => {
  return processingChannels.filter((channel) => acceptedEntityIds.includes(channel.entityId));
};
